var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0003 2.52075C8.84872 2.52075 7.10449 4.26498 7.10449 6.41659C7.10449 8.56819 8.84872 10.3124 11.0003 10.3124C13.1519 10.3124 14.8962 8.56819 14.8962 6.41659C14.8962 4.26498 13.1519 2.52075 11.0003 2.52075ZM5.72949 6.41659C5.72949 3.50558 8.08932 1.14575 11.0003 1.14575C13.9113 1.14575 16.2712 3.50558 16.2712 6.41659C16.2712 9.32759 13.9113 11.6874 11.0003 11.6874C8.08932 11.6874 5.72949 9.32759 5.72949 6.41659Z",
    fill: "#D4AF37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43848 20.1667C2.43848 16.1142 6.41417 13.0625 11.0001 13.0625C15.5861 13.0625 19.5618 16.1142 19.5618 20.1667C19.5618 20.5464 19.254 20.8542 18.8743 20.8542C18.4946 20.8542 18.1868 20.5464 18.1868 20.1667C18.1868 17.1241 15.1042 14.4375 11.0001 14.4375C6.89611 14.4375 3.81348 17.1241 3.81348 20.1667C3.81348 20.5464 3.50567 20.8542 3.12598 20.8542C2.74628 20.8542 2.43848 20.5464 2.43848 20.1667Z",
    fill: "#D4AF37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActive);
export default __webpack_public_path__ + "static/media/user-active.0009faad5d5feb171cf242b7cfeea6da.svg";
export { ForwardRef as ReactComponent };